import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  subtitle: {
    id: 'pib_learn_section_title_1',
  },
  vocabularyCta: {
    id: 'pib_learn_vocabulary',
  },
  bottomSectionTitle: {
    id: 'pib_learn_bottom_section_title',
  },
  bottomSectionDescription: {
    id: 'pib_learn_bottom_section_description',
  },
  learningCta: {
    id: 'pib_communicate_section_cta',
  },
  pibLearn: {
    id: 'pib_learn',
  },
  pibImmerse: {
    id: 'pib_immerse',
  },
});

export const en_us = defineMessages({
  title: {
    id: 'pib_learn_section_title_2_en',
  },
  description: {
    id: 'pib_learn_section_description_en',
  },
  leftSectionTitle: {
    id: 'pib_learn_top_section_title_en',
  },
  leftSectionDescription: {
    id: 'pib_learn_immerse_description_en',
  },
  topSectionDescription: {
    id: 'pib_learn_top_section_description_en',
  },
});

export const es = defineMessages({
  title: {
    id: 'pib_learn_section_title_2_es',
  },
  description: {
    id: 'pib_learn_section_description_es',
  },
  leftSectionTitle: {
    id: 'pib_learn_top_section_title_es',
  },
  leftSectionDescription: {
    id: 'pib_learn_immerse_description_es',
  },
  topSectionDescription: {
    id: 'pib_learn_top_section_description_es',
  },
});
